import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CatalogsService } from 'src/app/catalogs/catalogs.service';
import { BlobStorageService } from '../../blobstorage.service';
import { IntakeUseCase } from '../../usecase/IntakeUseCase';


@Component({
    selector: 'document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit {
    mainForm: FormGroup;
    documentTypes = [];
    files: any[] = [];

    constructor(private fb: FormBuilder, private route: ActivatedRoute,
        private catalogsService: CatalogsService, 
        private blobStorageService: BlobStorageService, 
        private intakeUseCase : IntakeUseCase, 
        private config: DynamicDialogConfig) {

        this.mainForm = fb.group({
            id:[],
            documentType:[null, Validators.required],
        });
    }

    ngOnInit(): void {
        this.catalogsService.findDocumentTypesAll().then(types => this.documentTypes = types);
    }

    uploadHandler(event) {
        console.log("upload", event);
    }

    selectFile(event) {
        this.files = [];
        event.currentFiles.forEach(f => this.files.push(f));
        console.log("upload", event);
    }

    removeFile(event) {
        let ix = this.files.indexOf(event.file);
        if(ix != -1) {
            this.files.splice(ix, 1);
            console.log("remove", event);    
        }
    }

    cancel() {
        this.intakeUseCase.closeDocument();        
    }
    
    store() {
        if(this.mainForm.valid) {
            Promise
            .all(this.files.map(file => this.blobStorageService.storeBlob(this.intakeUseCase.case.id, this.mainForm.value.documentType, file)))
            .then(responses => this.intakeUseCase.appendDocuments(responses.map(fileInfo => this.toDocument(fileInfo))));
        }
    }

    toDocument(fileInfo) {
        return {type: this.mainForm.value.documentType, fileInfo: fileInfo};
    }
}